import AxiosClient from "../AxiosClient";

export const searchCustomerInfoList = (params) => {
  const url = "/api/customer/searchInfoList";
  return AxiosClient.post(url, params);
};

export const insertCustomerInfo = (params) => {
  const url = "/api/customer/insertInfo";
  return AxiosClient.post(url, params);
};

export const updateCustomerInfo = (params) => {
  const url = "/api/customer/updateInfo";
  return AxiosClient.post(url, params);
};

export const deleteCustomerInfo = (params) => {
  const url = "/api/customer/deleteInfo";
  return AxiosClient.post(url, params);
};

export const searchShopInfoList = (params) => {
  const url = "/api/shop/searchInfoList";
  return AxiosClient.post(url, params);
};

export const insertShopInfo = (params) => {
  const url = "/api/shop/insertInfo";
  return AxiosClient.post(url, params);
};

export const updateShopInfo = (params) => {
  const url = "/api/shop/updateInfo";
  return AxiosClient.post(url, params);
};

export const deleteShopInfo = (params) => {
  const url = "/api/shop/deleteInfo";
  return AxiosClient.post(url, params);
};